import get from 'lodash/get';
import { getSkuInfoMapWithSkuInfoList } from '../services/SkuSearch';
import { auth } from '../utils/auth';

const createPriceManagerLink = ({ id, revisionId }) => {
  return `${process.env.REACT_APP_PRICINGMANAGER_URL}/models/${id}?revision=${revisionId}`;
};

export const skuInfoToPriceModelAndSkuRows = async (skuList, items) => {
  const { skuMap } = await getSkuInfoMapWithSkuInfoList(skuList, auth.getAccessToken, true);
  const skuInfoList = Object.values(skuMap);

  return skuInfoList.map(({ sku, name, description, fulfiller }) => {
    // Because some sku descriptions have new line breaks and other special characters, we need to escape them
    description = JSON.stringify(description);

    const row = {
      sku,
      name,
      description,
      fulfillerName: fulfiller && fulfiller.name,
      fulfillerId: fulfiller && fulfiller.fulfillerId
    };

    if (items) {
      const priceModel = get(items, `[${sku}].priceModel`);

      row.priceManagerUrl = createPriceManagerLink(priceModel);
      row.priceModelId = priceModel.id;
      row.priceModelRevisionId = priceModel.revisionId;
    }

    return row;
  });
};
